import { render, staticRenderFns } from "./TempoEstoque.vue?vue&type=template&id=71ddab21"
import script from "./TempoEstoque.vue?vue&type=script&lang=js"
export * from "./TempoEstoque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports